import { ADDON_CATEGORIES } from "./types";
import type { AddonCategory } from "./types";

/**
 * The human-readable label for an add-on category, or `null` when there is
 * nothing to show.
 *
 * `null` (never classified), `undefined` (a server that has not yet
 * deployed the `category` field), and any category value this build does
 * not recognize all degrade the same way — no badge — rather than crashing
 * or rendering a raw enum value.
 */
export function addonCategoryLabel(
  category: AddonCategory | null | undefined,
): string | null {
  if (category == null) return null;

  const match = ADDON_CATEGORIES.find((entry) => entry.value === category);
  return match?.label ?? null;
}
